import React from 'react';

import { skills } from '../../Data/Data';

import './Skills.scss';
import { useInView } from 'react-intersection-observer';

const Skills = () => {
  const { ref: ref1, inView: headerIntersecting } = useInView({
    threshold: 0.9,
    triggerOnce: true,
  });

  const { ref: ref3, inView: cardsIntersecting } = useInView({
    threshold: 1,
    triggerOnce: true,
  });

  // const [secondIntersecting, setSecondIntersecting] = useState(false);

  // useEffect(() => {
  //   const observer = new IntersectionObserver(
  //     (entries) => {
  //       const entry = entries[0];
  //       setIntersecting(entry.isIntersecting);
  //     },
  //     { threshold: 0.8 }
  //   );
  //   observer.observe(ref.current);

  //   const secondObserver = new IntersectionObserver(
  //     (entries) => {
  //       const entry = entries[0];
  //       setSecondIntersecting(entry.isIntersecting);
  //     },
  //     { threshold: 0.8 }
  //   );
  //   secondObserver.observe(ref2.current);
  // }, []);

  // const { aboutHeight } = useContext(context);
  // useEffect(() => {
  //   const handleScroll = () => {
  //     setScrollY(window.scrollY);
  //     setDivHeight(ref.current.offsetHeight);
  //     setDifHeight(divHeight - scrollY);

  //     if (window.scrollY > 0 && window.scrollY - aboutHeight < divHeight) {
  //       setScrollY(window.scrollY - aboutHeight);
  //     } else {
  //       setScrollY(0);
  //     }
  //     setTranslate((10 * scrollY) / 100);

  //     if (difHeight <= divHeight / 2) {
  //       setFade(true);
  //     } else {
  //       setFade(false);
  //     }
  //   };

  //   window.addEventListener('scroll', handleScroll);
  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, [divHeight, scrollY, difHeight]);

  return (
    <div
      id="technologies"
      className={`  min-h-screen w-full border-b-2 bg-slate-900 border-teal-400`}
    >
      <div className=" flex flex-col gap-5 pt-5  pb-16">
        <div
          ref={ref1}
          className={`${
            !headerIntersecting && 'md:opacity-50'
          } flex flex-col gap-3`}
        >
          <div className="relative">
            <h1
              bg-text="Technologies I Use"
              className={`${
                headerIntersecting && '  headingRocks heading__text'
              }  sm:text-[5rem] text-[3rem] sm:px-0 px-2 sm:before:px-0 before:px-2 sm:after:px-0 after:px-2 text-center text-teal-400  font-outfit  font-semibold mt-5`}
            >
              Technologies I Use{' '}
            </h1>
          </div>
          <p
            className={`${
              headerIntersecting && 'info'
            }  text-teal-200 brightness-125 text-xl tracking-wide text-center px-5 font-outfit`}
          >
            These are the technologies i am most confident with and used in all
            of my projects
          </p>
        </div>
        <div
          className={`${
            !cardsIntersecting && 'md:opacity-50'
          } flex gap-3 justify-center flex-wrap px-5 mt-5`}
        >
          {skills.map((skill) => {
            return (
              <div
                ref={ref3}
                key={skill.title}
                className={`${
                  cardsIntersecting && skill.anime
                } ring-4 ring-black relative flex flex-col items-center justify-center  bg-gradient-to-r from-[#011318] to-slate-900 p-3 ${
                  skill.color
                } font-EastSea text-3xl rounded-md shadow-sm shadow-teal-400  ${
                  skill.bgColor
                }`}
              >
                <img
                  src={skill.img}
                  alt={skill.title}
                  className="w-24 h-24 object-contain"
                />
                <h1>{skill.title}</h1>
              </div>
            );
          })}
        </div>
      </div>
      {/* <div
        ref={ref4}
        className={`${
          !secondIntersecting && 'md:opacity-50'
        } flex flex-col items-center mt-5`}
      >
        <h1
          bg-text="I Am Currently Learning"
          className={`${
            secondIntersecting && 'heading heading__text2'
          } sm:text-[3rem] text-[2rem]  `}
        >
          I Am Currently Learning
        </h1>
        <div className="flex gap-3 justify-center flex-wrap px-5 mt-5">
          <div
            className={`${
              secondIntersecting && 'heading'
            } transition-all ease-out flex flex-col items-center justify-center bg-gradient-to-r from-slate-800 to-slate-900 p-3  font-EastSea text-3xl rounded-md shadow-sm shadow-teal-400`}
          >
            <SiNextdotjs
              alt="nextjs"
              className="w-24 h-24 object-contain fill-black bg-white bg-contain rounded-full"
            />
            <h1 className={` text-white`}>Next</h1>
          </div>
          <div
            className={`${
              secondIntersecting && 'info'
            } transition-all ease-out flex flex-col items-center justify-center bg-gradient-to-r from-slate-800 to-slate-900 p-3  font-EastSea text-3xl rounded-md shadow-sm shadow-teal-400`}
          >
            <SiTypescript
              alt="typescript"
              className="w-24 h-24 object-contain text-blue-600 bg-white rounded-full bg-contain"
            />
            <h1 className="text-blue-500">TypeScript</h1>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Skills;
